import { PushNotifications } from '@capacitor/push-notifications';
import { isCordovaBuild } from '../lib/cordovaHelpers';

export const ResetIosBadgeCount = () => {
    if (isCordovaBuild) {
        PushNotifications.removeAllDeliveredNotifications();
    }
};
